import { usePrevious } from '@eti/utils';
import { useDidUpdateEffect } from '../../custom-hooks/useDidUpdateEffect';
import { getIdOfFirstUnselectedTraveler, getSegmentTravelers } from '../utils/travelerUtils';
import { focusOnNextSegmentButton, isCabinLayoutShown } from '../utils/focusUtils';
import { announceAllPassengersAreSeated } from '../utils/a11yUtils';
export const useSeatMapAutoAdvance = ({
  activeSegment,
  activeTraveler,
  flattenedBounds,
  foundSegment,
  fromSummary,
  getSelected,
  isManualNavigationEnabled,
  isSeatPreferenceAvailable,
  selectedSeats,
  travelers,
  t,
  onChangeTraveler,
  onNextSegment
}) => {
  var _getSelected, _getSelected$find;
  const prevSelectedSeatsInSegmentCount = usePrevious((_getSelected = getSelected(activeSegment)) === null || _getSelected === void 0 ? void 0 : _getSelected.length);
  const prevActiveSegment = usePrevious(activeSegment);
  const prevSelectedSeats = usePrevious(selectedSeats);
  const activeTravelerSeatValue = (_getSelected$find = getSelected(activeSegment).find(s => s.id === activeTraveler)) === null || _getSelected$find === void 0 ? void 0 : _getSelected$find.value;
  const prevActiveTravelerSeatValue = usePrevious(activeTravelerSeatValue);
  useDidUpdateEffect(() => {
    var _foundSegment$travele;
    if (!foundSegment) {
      return;
    }
    if (prevSelectedSeats === selectedSeats && prevActiveSegment === activeSegment) {
      return;
    }
    const cabinLayoutShown = isCabinLayoutShown();
    const selectedSeatsInSegmentCount = getSelected(activeSegment).length;
    const allSelected = Boolean((_foundSegment$travele = foundSegment.travelerIds) === null || _foundSegment$travele === void 0 ? void 0 : _foundSegment$travele.length) && selectedSeatsInSegmentCount === foundSegment.travelerIds.length;
    const selectedSeatsChanged = prevSelectedSeats !== selectedSeats;
    const activeSegmentChanged = prevActiveSegment !== activeSegment;
    const shouldAutoAdvanceSegment = selectedSeatsChanged || activeSegmentChanged;
    if (isSeatPreferenceAvailable) {
      focusOnNextSegmentButton();
    } else if (isManualNavigationEnabled && cabinLayoutShown && allSelected) {
      announceAllPassengersAreSeated(t('ScreenReader.Seating.AllPassengersSeated.text'));
      focusOnNextSegmentButton();
    } else if (shouldAutoAdvanceSegment && isManualNavigationEnabled && allSelected) {
      focusOnNextSegmentButton();
    } else if (!isManualNavigationEnabled && selectedSeatsInSegmentCount !== prevSelectedSeatsInSegmentCount && allSelected) {
      onNextSegment();
    }
    const seatWasJustSelected = selectedSeatsChanged && activeTravelerSeatValue !== undefined && prevActiveTravelerSeatValue !== activeTravelerSeatValue;
    if (seatWasJustSelected && prevActiveSegment === activeSegment) {
      const nextUnselectedTraveler = getIdOfFirstUnselectedTraveler(getSegmentTravelers(travelers, flattenedBounds, activeSegment), getSelected(activeSegment), activeTraveler);
      if (nextUnselectedTraveler !== null) {
        onChangeTraveler(nextUnselectedTraveler);
      }
    }
  }, [selectedSeats, prevSelectedSeats, foundSegment, activeSegment, activeTraveler, flattenedBounds, fromSummary, getSelected, isManualNavigationEnabled, isSeatPreferenceAvailable, prevSelectedSeatsInSegmentCount, activeTravelerSeatValue, prevActiveTravelerSeatValue, travelers, t, onChangeTraveler, onNextSegment]);
};
//# sourceMappingURL=useSeatMapAutoAdvance.js.map